import {
  FAILED as HEALTH_FAILED,
  RECEIVED as HEALTH_RECEIVED,
  REQUESTING as HEALTH_REQUESTING,
} from '../types/health';
import { SIGNATURE } from '../types/system';

export type SystemState = {
  readonly loaded: boolean;
  readonly signature: string;
  readonly status: string;
  readonly status_failed: boolean;
  readonly status_requesting: boolean;
  readonly api: string;
  readonly domain: string;
  readonly payfortCashewID: string;
  readonly payfortCashewCode: string;
  readonly payfortPaymentAPI: string;
  readonly payfortCheckoutAPI: string;
};

const initialState: SystemState = {
  loaded: false,
  signature: '',
  status: '',
  status_requesting: false,
  status_failed: false,
  api: '',
  domain: '',
  payfortCashewID: '',
  payfortCashewCode: '',
  payfortPaymentAPI: '',
  payfortCheckoutAPI: '',
};

export default function reducer(
  state: SystemState = initialState,
  action: any = {}
) {
  switch (action.type) {
    case 'persist/REHYDRATE':
      return {
        ...state,
        api: process.env.REACT_APP_API,
        domain: process.env.REACT_APP_DOMAIN,
        payfortCashewID: process.env.REACT_APP_PAYFORT_MERCHANT_ID,
        payfortCashewCode: process.env.REACT_APP_PAYFORT_MERCHANT_CODE,
        payfortPaymentAPI: process.env.REACT_APP_PAYFORT_PAYMENT_API,
        payfortCheckoutAPI: process.env.REACT_APP_PAYFORT_CHECKOUT_API,
        loaded: true,
      };
    case HEALTH_RECEIVED:
      return {
        ...state,
        status: action.status,
        status_failed: false,
        status_requesting: false,
      };
    case HEALTH_REQUESTING:
      return {
        ...state,
        status_requesting: true,
        status_failed: false,
      };
    case HEALTH_FAILED:
      return {
        ...state,
        status_requesting: false,
        status_failed: true,
      };
    case SIGNATURE:
      return { ...state, signature: action.payload };
    default:
      return state;
  }
}
